/* eslint-disable @typescript-eslint/no-explicit-any */
import { PureComponent } from 'react';

import { reactMethodNames } from './reactMethodNames';
/**
 * Autobinds all methods
 */
export default class PureBaseComponent<Props = {}, State = {}> extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    Object.getOwnPropertyNames(Object.getPrototypeOf(this)).forEach((method) => {
      if (typeof (this as any)[method] !== 'function' || reactMethodNames.indexOf(method) !== -1) {
        return;
      }
      (this as any)[method] = (this as any)[method].bind(this);
    });
  }
}
